import { render, staticRenderFns } from "./DriversSummary.vue?vue&type=template&id=9420a0f0&"
import script from "./DriversSummary.vue?vue&type=script&lang=js&"
export * from "./DriversSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports